angular.module('picmonicng').controller('SearchController', [
  '$scope',
  '$state',
  '$stateParams',
  'Pathways',
  'Picmonics',
  'MarketOptionsConfig',
  'UserService',
  '$filter',
  '$browseStateParams',
  'SearchService',
  'BrowseService',
  'SearchHistoryResource',
  'PermissionsService',
  'PlaylistService',
  function (
    $scope,
    $state,
    $stateParams,
    Pathways,
    Picmonics,
    MarketOptionsConfig,
    UserService,
    $filter,
    $browseStateParams,
    SearchService,
    BrowseService,
    SearchHistoryResource,
    PermissionsService,
    PlaylistService
  ) {
    $scope.results = {}; // Search results
    $scope.lastSearchTime = new Date().getTime();
    $scope.page = $stateParams.p || $browseStateParams.p || 1; // Current page
    $scope.searchTerm = $browseStateParams.q || $stateParams.q || SearchService.searchTerm;
    if ($browseStateParams.q === '') {
      $scope.searchTerm = SearchService.searchTerm = '';
    } else {
      SearchService.searchTerm = $scope.searchTerm;
    }
    $scope.mobileFilterVisiblity = false;
    $scope.$stateParams = $stateParams || $browseStateParams;

    $scope.filters = SearchService.filters;
    $scope.selected_filters = SearchService.selected_filters;
    if (UserService.user.user_id) {
      $scope.selected_filters.ugc = UserService.user.ugc_search ? true : false;
    }

    $scope.PermissionsService = PermissionsService;
    $scope.PlaylistService = PlaylistService;
    if (!PlaylistService.initialPromise) {
      PlaylistService.init();
    }

    // Mobile filter state
    // Available sorting options
    $scope.sort_options = [
      { label: 'Relevance', value: 'relevance', hidden: true },
      { label: 'A-Z', value: 'a-z' },
      { label: 'Recent', value: 'recent' },
      { label: 'Newest', value: 'newest' },
      { label: 'Updated', value: 'updated' },
    ];
    // Active sorting option
    $scope.sorting = $browseStateParams.sort_by || $scope.sort_options[0];

    $scope.$watch('sorting.value', function (value, old) {
      if (old != value) {
        atlasEvent('click', 'search_sort_' + value);
      }
    });

    // Load states
    $scope.loading = {
      initial: false,
      user: false,
      results: false,
      more: false,
    };

    // Pending load states
    $scope.pending = {
      reset: false,
      results: false,
      more: false,
    };
    if ($browseStateParams.onlyPicmonics) {
      $scope.selected_filters.what = 'picmonics';
    } else if ($browseStateParams.onlyPathways) {
      $scope.selected_filters.what = 'pathways';
    } else if (SearchService.selected_filters.what) {
      $scope.selected_filters.what = SearchService.selected_filters.what;
    } else {
      $scope.selected_filters.what = 'everything';
    }

    // Load the user object (for market info & available pathway types)
    $scope.pathway_types = [];
    var market = MarketOptionsConfig.getMarketById(UserService.user.lead);
    $scope.pathway_types = [].concat(market.sections);
    $scope.loading.user = false;
    if ($scope.loading.results == false) {
      $scope.loading.initial = false;
    }

    $scope.dropdownExpanded = {
      types: true,
    };

    // Reset the search results and state
    $scope.resetSearch = function () {
      $scope.results = {
        cards: [],
        pathways: [],
        topics: [],
        total: 0,
        pages: 0,
      };
      $scope.page = 1;
    };

    // Fetch the search results
    $scope.getResults = function (request) {
      SearchService.searching = true;
      // Approximate counts when searching for nothing (performance)
      if (!request.query || !request.query.length) {
        request.heuristic = true;
      }
      var results = Picmonics.search(request);
      results.$promise.finally(function () {
        $scope.lastSearchTime = new Date().getTime();

        if (!$scope.loading.more) {
          $scope.results.cards = [];
          $scope.results.pathways = [];
          $scope.results.topics = [];
          $scope.results.playlists = [];
        }
        $scope.results.cards = $scope.results.cards.concat(results.cards);
        $scope.results.pathways = $scope.results.pathways.concat(results.pathways);
        $scope.results.playlists = $scope.results.playlists.concat(results.playlists);
        $scope.results.topics = $scope.results.topics.concat(results.topics);
        if (results.total != null) {
          $scope.results.total = results.total;
          $scope.results.pages = results.pages;
        }
        $scope.loading.results = false;
        $scope.loading.more = false;
        if (!$scope.loading.users) {
          $scope.loading.initial = false;
        }

        $scope.filters = results.filters;

        if ($scope.pending.results) {
          var loadMore = $scope.pending.more;
          $scope.pending.results = false;
          $scope.pending.more = false;
          $scope.runSearch(loadMore);
        }

        SearchService.searching = false;
      });
      return results;
    };

    $scope.clearSearch = function () {
      $scope.searchTerm = '';
      $stateParams.q = '';
      $state.go('.', { q: '' });
      $scope.resetAndRunSearch();
      SearchService.reset();
    };

    $scope.resetAndRunSearch = function () {
      $scope.resetSearch();

      if (
        $scope.selected_filters.what == 'everything' &&
        $scope.sorting &&
        $scope.sorting.value != 'a-z' &&
        $scope.sorting.value != 'relevance'
      ) {
        $scope.selected_filters.what = 'picmonics';
      }

      $scope.runSearch();
    };

    // Attempt to execute a search
    $scope.runSearch = function (loadMore, ignoreFilters) {
      if (loadMore && $scope.page >= $scope.results.pages) {
        return false;
      }

      if (!$scope.searchTerm && $scope.sorting.value == 'relevance') {
        $scope.sorting = $scope.sort_options[1];
      } else if ($scope.searchTerm) {
        $scope.sorting = $scope.sort_options[0];
      }

      if ($scope.loading.results) {
        $scope.pending.results = true;
        $scope.pending.more = loadMore;
      } else {
        if (loadMore === true) {
          $scope.page++;
          $scope.loading.more = true;
        } else if (loadMore === false) {
          $scope.resetSearch();
        } else if (typeof loadMore == 'number') {
          $scope.page = loadMore;
        }

        $scope.loading.results = true;

        var filters = {};
        if ($scope.selected_filters.bookmarked) {
          filters.bookmarked = true;
        }
        if ($scope.selected_filters.track) {
          filters.track_id = $scope.selected_filters.track.track_id;
        }
        if ($scope.selected_filters.sub_pathway) {
          filters.sub_pathway_id = $scope.selected_filters.sub_pathway.sub_pathway_id;
        }
        if ($scope.selected_filters.root_pathway) {
          filters.root_pathway_id = $scope.selected_filters.root_pathway.root_pathway_id;
        }
        if ($scope.selected_filters.pathway_type) {
          filters.pathway_type = $scope.selected_filters.pathway_type.pathway_type;
        }

        var request = {
          source: $scope.ltiSelect ? 'lti_selection' : 'spotlight',
          query: $scope.searchTerm,
          page: $scope.page,
          searchPicmonics: ['picmonics', 'everything'].indexOf($scope.selected_filters.what) != -1,
          searchPathways: ['pathways', 'everything'].indexOf($scope.selected_filters.what) != -1,
          searchPlaylists: ['playlists', 'everything'].indexOf($scope.selected_filters.what) != -1,
          searchBreadcrumbs: true,
          sort_by: $scope.sorting.value,
          include_ugc: $scope.ltiSelect ? false : $scope.selected_filters.ugc,
          show_archived: $scope.ltiSelect ? false : $scope.selected_filters.show_archived,
          admin: $scope.selected_filters.admin,
        };

        request.filters = ignoreFilters ? {} : filters;

        if ($scope.selected_filters.what == 'pathways') {
          request.pathways_limit = 25;
        }

        $scope.getResults(request);
      }
      $scope.$emit('endInteraction');
    };

    // Clear the currently assigned filters & sorting option
    $scope.clearFilters = function () {
      $scope.sorting = $scope.sort_options[0];
      $scope.clearBookmarked();
      $scope.clearType();
      $scope.runSearch(false);
    };

    // Enable the bookmarked filter
    $scope.selectBookmarked = function () {
      $scope.selected_filters.what = 'picmonics';
      $scope.selected_filters.bookmarked = true;
      $scope.runSearch(false);
    };

    // Clear the bookmarked filter
    $scope.clearBookmarked = function () {
      $scope.selected_filters.bookmarked = false;
      $scope.runSearch(false);
    };

    // Select a filter and determine which type it is based on existing selection
    $scope.selectFilter = function (filter) {
      if (!$scope.selected_filters.pathway_type) {
        $scope.selected_filters.pathway_type = filter;
        atlasEvent('click', 'search_filter_' + filter.name);
      } else if (!$scope.selected_filters.root_pathway) {
        $scope.selected_filters.root_pathway = filter;
        atlasEvent('click', 'search_filter_' + $scope.selected_filters.pathway_type.name + '_lvl1');
      } else if (!$scope.selected_filters.sub_pathway) {
        $scope.selected_filters.sub_pathway = filter;
        atlasEvent('click', 'search_filter_' + $scope.selected_filters.pathway_type.name + '_lvl2');
      } else {
        $scope.selected_filters.track = filter;
        atlasEvent('click', 'search_filter_' + $scope.selected_filters.pathway_type.name + '_lvl3');
      }
      $scope.filters = [];
      $scope.runSearch(false);
    };

    $scope.toggleUGCResults = function () {
      UserService.see('search_ugc');
      UserService.user.ugc_search = !$scope.selected_filters.ugc ? 1 : 0;
      UserService.user.$update();

      $scope.selected_filters.ugc = !$scope.selected_filters.ugc;

      $scope.runSearch();
    };

    $scope.toggleArchived = function () {
      $scope.selected_filters.show_archived = !$scope.selected_filters.show_archived;
      $scope.runSearch();
    };

    $scope.toggleAdmin = function () {
      $scope.selected_filters.admin = !$scope.selected_filters.admin;
      $scope.runSearch();
    };

    // Select a pathway type
    $scope.selectType = function (type) {
      $scope.selected_filters.pathway_type = type;
      $scope.runSearch(false);
    };

    // Clear the selected pathway type
    $scope.clearType = function () {
      $scope.selected_filters.pathway_type = false;
      $scope.selected_filters.root_pathway = false;
      $scope.selected_filters.sub_pathway = false;
      $scope.selected_filters.track = false;
      $scope.runSearch(false);
    };

    // Select the root pathway
    $scope.selectRootPathway = function (pathway) {
      $scope.selected_filters.root_pathway = pathway;
      $scope.runSearch(false);
    };

    // Clear the selected primary pathway
    $scope.clearRootPathway = function () {
      $scope.selected_filters.root_pathway = false;
      $scope.selected_filters.sub_pathway = false;
      $scope.selected_filters.track = false;
      $scope.runSearch(false);
    };

    // Select the sub pathway
    $scope.selectSubPathway = function (pathway) {
      $scope.selected_filters.sub_pathway = pathway;
      $scope.runSearch(false);
    };

    // Clear the selected secondary pathway
    $scope.clearSubPathway = function () {
      $scope.selected_filters.sub_pathway = false;
      $scope.selected_filters.track = false;
      $scope.runSearch();
    };

    // Clear the selected track
    $scope.clearTrack = function () {
      $scope.selected_filters.track = false;
      $scope.runSearch(false);
    };

    // Toggle mobile filter visibility
    $scope.toggleMobileFilters = function ($event) {
      $event.stopPropagation();
      $event.preventDefault();

      if ($scope.mobileFilterVisiblity) {
        $scope.closeMobileFilters();
      } else {
        $scope.openMobileFilters();
      }
    };

    $scope.openMobileFilters = function () {
      $scope.addMobileFiltersClickToClose();
      $scope.mobileFilterVisiblity = true;
    };

    $scope.closeMobileFilters = function () {
      $scope.removeMobileFiltersClickToClose();
      $scope.mobileFilterVisiblity = false;
    };

    $scope.clickHandler = function (e) {
      var element = angular.element('.search--filter');
      if (
        $scope.mobileFilterVisiblity == true &&
        element[0] != e.target &&
        !angular.element(element).has(angular.element(e.target)).length
      ) {
        e.stopPropagation();
        e.preventDefault();
        $scope.closeMobileFilters();
        $scope.$apply();
      }
    };

    $scope.addMobileFiltersClickToClose = function () {
      document.body.addEventListener('click', $scope.clickHandler, true);
    };

    $scope.removeMobileFiltersClickToClose = function () {
      document.body.removeEventListener('click', $scope.clickHandler, true);
    };

    $scope.saveClickHistory = function (card, $index) {
      SearchHistoryResource.save({
        search_origin: 'spotlight',
        search_term: $scope.searchTerm,
        result_position: $index,
        result_time_till_click: new Date().getTime() - $scope.lastSearchTime,
        resource_type: 'picmonic',
        resource_id: card.card_id,
        action_type: 'select_card',
      });
    };

    // Navigate to the provided pathway
    $scope.goToPathway = function (pathway, $index) {
      SearchHistoryResource.save({
        search_origin: 'spotlight',
        search_term: $scope.searchTerm,
        result_position: $index,
        result_time_till_click: new Date().getTime() - $scope.lastSearchTime,
        resource_type: pathway.track_id ? 'track' : 'pathway',
        resource_id: pathway.track_id ? pathway.track_id : pathway.pathway_id,
        action_type: pathway.track_id ? 'select_track' : 'select_pathway',
      });

      BrowseService.go(
        'app.pathways.market.' + pathway.pathway_type + '.tracks' + (pathway.track_id ? '.picmonics' : ''),
        {
          curriculum: pathway.curriculum,
          market: MarketOptionsConfig.getMarketById(pathway.market_id).slug,
          pathway_id: pathway.pathway_id,
          track_id: pathway.track_id,
          scroll_to: pathway.tertiary_pathway_id ? pathway.tertiary_pathway_id : pathway.sub_pathway_id,
        }
      );
    };

    $scope.goToPlaylist = function (playlist, $index) {
      SearchHistoryResource.save({
        search_origin: 'spotlight',
        search_term: $scope.searchTerm,
        result_position: $index,
        result_time_till_click: new Date().getTime() - $scope.lastSearchTime,
        resource_type: 'playlist',
        resource_id: playlist.playlist_id,
        action_type: 'select_playlist',
      });

      BrowseService.go('app.playlists.playlist', {
        playlist_id: playlist.playlist_id,
      });
    };

    // Select the provided tab and update the search results
    $scope.selectTab = function (tab) {
      SearchService.selected_filters.what = $scope.selected_filters.what = tab;

      if (tab != 'picmonics') {
        $scope.sorting = $filter('filter')($scope.sort_options, { value: 'a-z' }, true)[0];
        $scope.selected_filters.bookmarked = false;
      }

      $scope.runSearch(false);
    };

    // Navigate to the next page of search results (triggered by infinite scroll)
    $scope.nextPage = function () {
      // Load more results
      if (
        !$scope.loadingMore &&
        !$scope.searching &&
        ($scope.results.pages > $scope.page + 1 || ($scope.page == 1 && $scope.results.pages == 1))
      ) {
        $scope.runSearch(true);
      }
    };

    // Search filter classnames, used to size the filter and results areas on mobile
    $scope.searchFilterClasses = function (classPrefix) {
      var obj = {};
      obj[classPrefix + '__bookmarked'] = $scope.selected_filters.bookmarked;
      obj[classPrefix + '__track'] = $scope.selected_filters.track;
      obj[classPrefix + '__subpathway'] = !$scope.selected_filters.track && $scope.selected_filters.sub_pathway;
      obj[classPrefix + '__pathway'] = !$scope.selected_filters.sub_pathway && $scope.selected_filters.root_pathway;
      obj[classPrefix + '__type'] = !$scope.selected_filters.root_pathway && $scope.selected_filters.pathway_type;
      return obj;
    };

    // Reset & execute a fresh search on load
    if (!$scope.ltiSelect || $scope.searchTerm) {
      $scope.runSearch(false);
    }
  },
]);
